import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useTranslation} from "react-i18next";

export interface DefaultDialogProps extends DialogProps {
    open: boolean;
    onClose: () => void;
    size?: DefaultDialogSize;
    titleKey?: string;
    children?: React.ReactNode | React.ReactNode[];
    actions?: React.ReactNode | React.ReactNode[];
}

export enum DefaultDialogSize {
    SMALL = 320,
    MEDIUM = 480,
    LARGE = 640,
    EXTRA_LARGE = 1024,
}

const DefaultDialog: React.FC<DefaultDialogProps> = ({
    open,
    onClose,
    size = DefaultDialogSize.MEDIUM,
    titleKey,
    children,
    actions,
    ...rest
}) => {
    const {t} = useTranslation();

    return (
        <Dialog
            sx={{"& .MuiDialog-paper": {width: size}}}
            open={open}
            onClose={onClose}
            scroll={"paper"}
            maxWidth={false}
            {...rest}
        >
            <DialogTitle display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                <Typography variant="h6" component={"div"} sx={{flexGrow: 1}}>
                    {titleKey && t(titleKey)}
                </Typography>
                <IconButton sx={{mr: -1}} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Grid container sx={{justifyItems: "space-between", justifyContent: "space-between", width: "100%"}}>
                    <Grid item>
                        <Button key="cancel" onClick={onClose}>
                            {t("action_cancel")}
                        </Button>
                    </Grid>
                    <Grid item sx={{justifyContent: "flex-end"}}>
                        {actions}
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};

export default DefaultDialog;
